/*=========================================================================================
  File Name: i18nLogin.js
  Description: File đa ngôn ngữ chung
  ----------------------------------------------------------------------------------------
  Project Name: MISA SME Cloud
    Author: NCThanh1
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	EmailNoConfirm: `Email chưa được xác thực`,
	PhoneNoConfirm: `Số điện thoại chưa được xác thực`,
	ConfirmMesPhoneNoPass: value =>
		`<div class="text-center"><span>Nhập mã gồm 6 ký tự đã gửi đến SĐT <span class="main-text">${value}</span> và thiết lập mật khẩu cho tài khoản</span></div>`,
	ConfirmMesEmailNoPass: value =>
		`<div class="text-center"><span>Nhập mã gồm 6 ký tự đã gửi đến Email <span class="main-text">${value}</span> và thiết lập mật khẩu cho tài khoản</span></div>`,
	ConfirmMesPhoneHasPass: value =>
		`<div class="text-center"><span>Nhập mã gồm 6 ký tự đã gửi đến SĐT <span class="main-text">${value}</span></span></div>`,
	ConfirmMesEmailHasPass: value =>
		`<div class="text-center"><span>Nhập mã gồm 6 ký tự đã gửi đến Email <span class="main-text">${value}</span></span></div>`,
	ConfirmMesApp: `<div class="text-center"><span>Nhập mã xác thực nhận từ các ứng dụng <span class="main-text">Google</span> & <span class="main-text">Microsoft Authenticator</span></span></div>`,
	MesHasPass: `Vui lòng nhập đúng mã xác thực vào ô dưới`,
	MesNoPass: `Vui lòng nhập đúng mã xác thực và thiết lập mật khẩu để đăng nhập từ những lần sau`,
	Copyright: value => `Copyright © 2012-${value} MISA JSC`,
	Login: `Đăng nhập`,
	Next: `Tiếp theo`,
	Back: `Quay lại`,
	ConfirmAccount: `Xác thực tài khoản`,
	NoReceivedVerify: `Không nhận được mã?`,
	Resend: `Gửi lại`,
	ForgotPassword: `Quên mật khẩu?`,
	InputPassword: `Nhập mật khẩu`,
	SendCodeAccuracy: `Gửi mã xác thực`,
	ReceivedVerifyByPhone: `Nhận mã xác thực qua SĐT`,
	ReceivedVerifyByEmail: `Nhận mã xác thực qua Email`,
	NoAccount: `Chưa có tài khoản?`,
	BuyNow: `Mua ngay`,
	PhoneOrEmail: `SĐT/Email`,
	Password: `Mật khẩu`,
	Confirm: `Xác nhận`,
	NoPermissionUseMtax: `Bạn chưa có quyền sử dụng dịch vụ MISA mTax`,
	NoFindAccount: `Không tìm thấy tài khoản`,
	ToarSuccessOTP: `Vui lòng đợi 60s mã xác nhận OTP đã gửi tới Email/SĐT của bạn`,
	ConfirmPasswordDifferent: `Mật khẩu xác nhận không khớp. Vui lòng kiểm tra lại.`,
	PasswordRetrieval: `Lấy lại mật khẩu`,
	ConfirmForgotPasswordMesEmail: value =>
		`<div class="text-center"><span>Mã xác thực sẽ được gửi đến Email <span class="main-text">${value}</span></span></div>`,
	ConfirmForgotPasswordMesPhone: value =>
		`<div class="text-center"><span>Mã xác thực sẽ được gửi đến SĐT </br><span class="main-text">${value}</span></span></div>`,
	InputConfirm: `Nhập mã xác thực`,
	IncorrectCode: `Mã xác thực không đúng. Vui lòng nhập lại`,
	ResetPassword: `Đặt lại mật khẩu`,
	NewPassword: `Mật khẩu mới`,
	ConfirmPassword: `Xác nhận mật khẩu`,
	ConfirmSuccess: `Xác thực thành công. Vui lòng đặt lại mật khẩu.`,
	ResetPasswordSuccess: `Đặt lại mật khẩu thành công`,
	VerifyTwoFactor: `Xác thực bảo mật hai lớp`,
	CodeConfirm: `Mã xác thực`,
	VerifyAnotherWay1: value =>
		`<div>Gửi đến số điện thoại </br><span class="main-text">${value}</span></div>`,
	VerifyAnotherWay2: value =>
		`<div>Gửi đến email </br><span class="main-text">${value}</span></div>`,
	VerifyAnotherWay3: `<div>Nhận mã xác thực từ các ứng dụng <span class="main-text">Google</span> & <span class="main-text">Microsoft Authenticator</span></div>`,
	ChooseMethodVerify: `Chọn phương thức nhận mã xác thực (OTP) để xác thực tài khoản và đăng nhập`,
	WrongPassword: `Mật khẩu sai. Vui lòng nhập lại`,
	ErrorContactMisa: `Đã có lỗi xảy ra vui lòng liên hệ MISA`,
	NoQuestionDevice: `Không hỏi lại trên thiết bị này`,
	TryAnotherWay: `Thử cách khác`,
	ChooseMethodVerifyTitle: `Chọn phương thức xác thực`,
	SelectTaxCodeText: 'Chọn mã số thuế làm việc',
	CanChangeTaxCodeFromSetting:
		'Bạn có thể thay đổi mã số thuế trong thiết lập',
	Role: value => {
		if (value == 1) return 'Quản trị';
	},
	ValidateLengthPassword: 'Ít nhất 8 ký tự',
	ValidateTextPassword: 'Chữ hoa,chữ thường',
	ValidateNumberPassword: 'Ít nhất 1 chữ số',
	SettingPasswordSuccess:
		'Thiết lập mật khẩu thành công/Vui lòng đăng nhập lại',
	YouStopActive:
		'Tài khoản của bạn đã bị ngừng kích hoạt trên mã số thuế này. Vui lòng liên hệ người dùng có vai trò quản trị để được hỗ trợ.',
	LoginAccountOther: 'Đăng nhập tài khoản khác',
	WrongTimes: 'Sai quá 3 lần, thử mã khác.',
	ActiveMisaStore: 'Kích hoạt giấy phép sử dụng',
};
